/**
* @file ViewForm.js

* @author - Team E (Meeramol Mathew, Krishnapriya N, Anju Sebastian)
* @sprint - B2W-Sprint-1
* @description - 
* This component displays a modal with detailed information about a selected record.
* It includes fields such as Action Item, Date, Ticket Number, Attachments, and Comments.
* The modal allows users to view details in a structured table format.
*/

import React from "react";
import { Modal, Button } from "antd";
import moment from 'moment';

/**
 * ViewForm Component
 *  
 *
 * @param {Object} props - Component properties
 * @param {boolean} props.visible - Determines if the modal is visible
 * @param {Function} props.onClose - Function to close the modal
 * @param {Object} props.selectedRecord - The record containing details to be displayed
 */

const ViewForm = ({ visible, onClose, selectedRecord }) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      width={800}
      footer={
        <div className="flex justify-end">
          <Button
            className="text-white px-6 py-2 bg-[var(--color-primary)] rounded-lg shadow-md hover:bg-[var(--color-secondary)] transition-all duration-200"
            onClick={onClose}
          >
            Close
          </Button>
        </div>
      }
      title={
        <div className="pt-2 pb-0 px-4 pl-0 rounded-lg">
          <span className="inline-block text-primary p-2 pl-0 text-xl">Details</span>
        </div>
      }
      className="text-gray-800"
    >
      {selectedRecord ? (
        <div className="p-0">
          <table className="w-full border-collapse border border-gray-300">
            <tbody>
              <tr className="border-b border-gray-300">
                <td className="px-4 py-2 font-bold text-[var(--color-primary)]">Action Item:</td>
                <td className="px-4 py-2 text-gray-700">{selectedRecord.actionItem}</td>
              </tr>

              <tr className="border-b border-gray-300">
                <td className="px-4 py-2 font-bold text-[var(--color-primary)]">Date:</td>
                <td className="px-4 py-2 text-gray-700" >{moment(selectedRecord.date, "DD-MM-YYYY").format('DD MMM YYYY')} </td>
              </tr>

              {selectedRecord.ticketNumber && (
                <tr className="border-b border-gray-300">
                  <td className="px-4 py-2 font-bold text-[var(--color-primary)]">Ticket Number:</td>
                  <td className="px-4 py-2 text-gray-700 uppercase">{selectedRecord.ticketNumber}</td>
                </tr>
              )}

              {selectedRecord.attachment && selectedRecord.attachment.length > 0 && (
                <tr className="border-b border-gray-300">
                  <td className="px-4 py-2 font-bold text-[var(--color-primary)]">Attachments:</td>
                  <td className="px-4 py-2 text-gray-700">
                    <ul className="m-0 p-0 list-none">
                      {selectedRecord.attachment.map((file, index) => (
                        <li key={index} className="m-0 p-0">
                          <span>{file.name}</span>
                        </li>
                      ))}
                    </ul>
                  </td>
                </tr>
              )}

              <tr>
                <td className="px-4 py-2 font-bold text-[var(--color-primary)]">Comments:</td>
                <td className="px-4 py-2 text-gray-700 capitalize">
                  {selectedRecord.comments || "No comment provided"}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-center text-gray-600">No details available.</p>
      )}
    </Modal>
  );
};

export default ViewForm;
